module.exports = __webpack_public_path__ + "assets/images/3fdfc64dbca630f884e74f3dce56e456.png";